import { useAppServices } from 'hook/services'
import React, { useEffect, useState } from 'react'

const KnowledgeBase = () => {
  const Service = useAppServices()
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [fetching, setFetching] = useState(false)

  const [formData, setFormData] = useState({
    dashboard: '',
    business: '',
    submission: '',
    consumer: '',
    branding: '',
    plans: '',
    settings: '',
    leads: '',
  })

  const getSetting = async () => {
    try {
      setFetching(true)
      const { response } = await Service.super_admin_settings.get()

      if (response?.success) {
        const kb = response?.data?.knowledge_base || {}

        setFormData({
          dashboard: kb.dashboard || '',
          business: kb.business || '',
          submission: kb.submission || '',
          consumer: kb.consumer || '',
          branding: kb.branding || '',
          plans: kb.plans || '',
          settings: kb.settings || '',
          leads: kb.leads || '',
        })
      }
    } catch (error) {
      console.error(error)
    } finally {
      setFetching(false)
    }
  }

  useEffect(() => {
    getSetting()
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSave = async () => {
    const knowledgebase = Object.fromEntries(
      Object.entries(formData).filter(([_, value]) => value && value.trim() !== '')
    )

    if (Object.keys(knowledgebase).length === 0) return

    const payload = { knowledge_base: knowledgebase }

    try {
      setLoading(true)
      const { response } = await Service.super_admin_settings.update({ payload })

      if (response?.success) {
        setMessage('Knowledge Base saved successfully')
        setTimeout(() => setMessage(''), 3000)
      }
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <style>{`
        .kb-container { padding: 24px; }
        .kb-title { font-size: 18px; font-weight: 600; margin-bottom: 16px; }
        .kb-card {
          background: #fff;
          border-radius: 12px;
          padding: 24px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }
        .kb-field { display: flex; flex-direction: column; margin-bottom: 16px; }
        .kb-label { font-size: 13px; font-weight: 500; margin-bottom: 6px; }
        .kb-input {
          padding: 10px 12px;
          border-radius: 8px;
          border: 1px solid #d1d5db;
          font-size: 14px;
        }
        .kb-actions {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          margin-top: 24px;
        }
        .kb-btn { padding: 6px 12px; border-radius: 8px; cursor: pointer; }
        .primary { background: #2f80ed; color: #fff; border: none; }
        .secondary { background: #f3f4f6; border: none; }
        .kb-success {
          background: #ecfdf5;
          color: #065f46;
          padding: 10px 14px;
          border-radius: 8px;
          margin-bottom: 16px;
          font-size: 14px;
        }
          .kb-loader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
}

.kb-loader {
  width: 42px;
  height: 42px;
  border: 4px solid #e5e7eb;
  border-top: 4px solid #2f80ed;
  border-radius: 50%;
  animation: kb-spin 0.9s linear infinite;
}

.kb-loader-text {
  margin-top: 12px;
  font-size: 14px;
  color: #6b7280;
}

@keyframes kb-spin {
  to {
    transform: rotate(360deg);
  }
}

      `}</style>

      {fetching ? (
        <div className="kb-loader-wrapper">
          <div className="kb-loader"></div>
          <p className="kb-loader-text">Loading Knowledge Base...</p>
        </div>
      ) : (
        <div className="kb-container">
          <h2 className="kb-title">Knowledge Base Settings</h2>

          {message && <div className="kb-success">{message}</div>}

          <div className="kb-card">
            {[
              { label: 'Dashboard', name: 'dashboard' },
              { label: 'Business', name: 'business' },
              { label: 'Submission', name: 'submission' },
              { label: 'Consumers', name: 'consumer' },
              { label: 'Branding', name: 'branding' },
              { label: 'Plans', name: 'plans' },
              { label: 'Settings', name: 'settings' },
              { label: 'Leads', name: 'leads' },
            ].map((field) => (
              <div className="kb-field" key={field.name}>
                <label className="kb-label">{field.label}</label>
                <input
                  type="text"
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  placeholder="Enter knowledge base link"
                  className="kb-input"
                />
              </div>
            ))}
          </div>

          <div className="kb-actions">
            <button className="kb-btn secondary">Cancel</button>
            <button className="kb-btn primary" onClick={handleSave} disabled={loading}>
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      )}
    </>
  )
}

export default KnowledgeBase
